import React from 'react';

type BrandTone = 'onDark' | 'onLight';

interface BrandLockupProps {
  /** onDark = white type for photo / navy backgrounds; onLight = navy type for white surfaces. */
  tone?: BrandTone;
  /** Smaller lockup for use inside form cards. */
  compact?: boolean;
  className?: string;
}

/** Canonical CaddieSight whole-logo asset for light and dark surfaces. */
const BrandLockup: React.FC<BrandLockupProps> = ({ tone = 'onDark', compact = false, className }) => {
  const classes = [
    'brand-lockup',
    tone === 'onLight' ? 'brand-lockup--on-light' : 'brand-lockup--on-dark',
    compact ? 'brand-lockup--compact' : '',
    className ?? '',
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <div className={classes}>
      <img
        className="brand-lockup__image"
        src={`${process.env.PUBLIC_URL}/${tone === 'onLight' ? 'wholelogo-navy.svg' : 'wholelogo-white.svg'}`}
        alt="CaddieSight — See the shot. Own the swing."
      />
    </div>
  );
};

export default BrandLockup;
